const labelLookUpTable = {
  dealType: 'price-rating',
  dealTypes: 'price-rating',
  doorCode: 'doors',
  doorCodes: 'doors',
  driveGroup: 'drive-type',
  endYear: 'year-max',
  engineCodes: 'cylinders',
  extColorSimple: 'exterior-color',
  extColorsSimple: 'exterior-color',
  featureCode: 'features',
  featureCodes: 'features',
  fuelTypeGroup: 'fuel-type',
  homeServices: 'dealer-home-services',
  intColorSimple: 'interior-color',
  interiorColorsSimple: 'interior-color',
  listingType: 'condition',
  listingTypes: 'condition',
  makeCode: 'make',
  makeCodeList: 'make',
  maxMileage: 'mileage',
  maxPrice: 'price-max',
  mileage: 'mileage',
  minPrice: 'price-min',
  modelCode: 'model',
  modelCodeList: 'model',
  mpgRange: 'fuel-economy',
  mpgRanges: 'fuel-economy',
  searchRadius: 'radius',
  sellerType: 'seller-type',
  sellerTypes: 'seller-type',
  seriesCodeList: 'series',
  startYear: 'year-min',
  transmissionCodes: 'transmission',
  trimCodeList: 'trim',
  vehicleStyleCode: 'body-style',
  vehicleStyleCodes: 'body-style',
  vehicleHistoryType: 'vehicle-history',
  vhrTypes: 'vehicle-history',
  zip: 'zip',
  trimCode: 'trim'
};
const filterNameTransformer = filterName => labelLookUpTable[filterName] || filterName;
export default filterNameTransformer;